import Router from "./infrastructure/navigation";

function App() {
  return <Router />;
}

export default App;
